module.exports = __webpack_public_path__ + "static/img/15.1e22953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/15.jpg
// module id = Q7Fa
// module chunks = 1